import React from "react"
import { ModulesYamlParts, ModulesYamlKinds } from "../../types/graphql-types"
import { KindList } from "./kinds"
import { WorkloadItem } from "./workloads"
import { graphql } from "gatsby"
import YamlData from "./yamldata"

export const modulesPartsQuery = graphql`
  fragment ModulesParts on ModulesYamlParts {
    kinds {
      kind
    }
    kind
    note
    subtitle
    workload {
      ...Workload
    }
  }
`

export const coursesPartsQuery = graphql`
  fragment CoursesParts on CoursesYamlParts {
    part {
      ...ModulesParts
    }
    appointments {
      ...Appointments
    }
  }
`

interface ModulePart {
  part: ModulesYamlParts
  className?: string
}

export const PartNote: React.FC<ModulePart> = ({ part, className = "" }) =>
  part.note ? <div class={className}>{part.note}</div> : <>{""}</>

interface PartItem extends ModulePart {
  children?: JSX.Element | JSX.Element[]
  className?: string
  courseKind?: ModulesYamlKinds
  coursePart?: ModulesYamlParts
  kindClassName?: string
  liClass?: string
}

export const PartItem: React.FC<PartItem> = ({
  part,
  coursePart,
  courseKind,
  children,
  className = "",
  liClass = "inline",
  kindClassName = "",
}) => (
  <li class={liClass}>
    <span class={`inline ${className}`}>
      {part.subtitle ? part.subtitle + " – " : ""}
      {part.kind}
      {coursePart &&
      courseKind &&
      part.kinds &&
      part.kinds.map(kind => kind.kind).includes(courseKind.kind) ? (
        <>{courseKind.kind}</>
      ) : part.kinds ? (
        <KindList kinds={part.kinds} className={kindClassName} />
      ) : (
        ""
      )}
    </span>
    <WorkloadItem workload={part.workload} />
    {children}
  </li>
)

interface PartsList {
  parts: ModulesYamlParts[]
  courseKind?: ModulesYamlKinds
  coursePart?: ModulesYamlParts
}

export const PartsList: React.FC<PartsList> = ({
  parts,
  courseKind,
  coursePart,
}) => (
  <ul class="inline">
    {parts.map((part, index) => (
      <PartItem
        part={part}
        key={index}
        courseKind={courseKind}
        coursePart={coursePart}
        liClass="inline comma-between and-before-last"
        className=""
      />
    ))}
  </ul>
)

export const PartDetails: React.FC<ModulePart> = ({ part }) => <></>
